import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Azione, GenericModalData } from "../common-component/generic-modal/generic-modal-data";
import { GenericModalComponent } from "../common-component/generic-modal/generic-modal.component";

@Injectable({
	providedIn: 'root'
})
export class Modals {

	constructor(private dialog: MatDialog) {
	}

	private AZIONE_DEFAULT: Array<Azione> = [new Azione("ok")];

	success(
		paragrafi: Array<string>,
		azioni: Array<Azione> = this.AZIONE_DEFAULT) {

		const modalData = this.buildModalData("modal-ok", paragrafi, azioni);
		this.openConfirm(modalData);
	}

	failure(
		paragrafi: Array<string>,
		azioni: Array<Azione> = this.AZIONE_DEFAULT) {

		const modalData = this.buildModalData("modal-ko", paragrafi, azioni);
		this.openConfirm(modalData);
	}

	private buildModalData(
		title: string, paragrafi: Array<string>, azioni: Array<Azione>)
		: GenericModalData {

		const data = new GenericModalData();
		data.title = title;
		data.paragrafi = paragrafi;
		data.azioni = azioni;
		return data;
	}

	openConfirm(modalData: GenericModalData) {
		this.dialog.open(GenericModalComponent, {
			data: modalData,
			panelClass: modalData.title === "modal-ok" ? 'custom-modalbox-ok' : 'custom-modalbox-ko'
		});
	}
}
